import React from 'react';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import TagChip from './TagChip';

const useStyles = makeStyles((theme) => ({
  card: {
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[8],
    },
  },
  titleLink: {
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  date: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  summary: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    lineHeight: 1.6,
  },
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
}));

const BlogPostCard = ({ post }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="h5" className={classes.title}>
          <Link to={`/blog/${post.slug}`} className={classes.titleLink}>
            {post.title}
          </Link>
        </Typography>

        <Typography variant="body2" className={classes.date}>
          {new Date(post.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </Typography>

        <Typography variant="body1" className={classes.summary}>
          {post.summary}
        </Typography>

        <Box className={classes.tags}>
          {post.tags &&
            post.tags.map((tag) => <TagChip key={tag} tag={tag} />)}
        </Box>
      </CardContent>
    </Card>
  );
};

export default BlogPostCard;
